import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

import useQuery from '@giro/shared-hooks/useQuery.hook';
import useListDebitsHook from '../hooks/useListDebits.hook';

import BilletComponent from './Billet.component';

import debits from '../store/list';
import apps from '@giro-app/store/apps';
import { useSelector } from 'react-redux';
import auth from '@giro/shared-store/auth';

const FirstRender = () => (
  <Box
    display="flex"
    flexDirection="column"
    gap={1}
    height="100%"
    justifyContent="center"
  >
    <Typography
      variant="h3"
      fontWeight={700}
      align="center"
      color="primary.main"
    >
      Faça a consulta através do código de barras
    </Typography>
    <Typography
      variant="body2"
      fontWeight={400}
      align="center"
      color="gray.400"
    >
      Digite o código de barras de boleto ou conta de consumo e clique em
      Consultar. Parcele o pagamento em até 18x.
    </Typography>
  </Box>
);

const NoFound = () => (
  <Box
    display="flex"
    flexDirection="column"
    gap={1}
    justifyContent="center"
    height="100%"
  >
    <Typography
      variant="h3"
      fontWeight={700}
      color="primary.main"
      align="center"
    >
      Não encontramos nenhum resultado para sua pesquisa
    </Typography>
    <Typography
      variant="body2"
      fontWeight={400}
      color="gray.400"
      align="center"
    >
      Pesquise novamente
    </Typography>
  </Box>
);

const DebtBilletComponent = () => {
  const selectorAppsRedux = {
    data: useSelector(apps.selector.selectData),
  };

  const [isValid, setValid] = React.useState(false);

  const { handleUpdateFilters } = useListDebitsHook();
  const { results = [], loading, error } = useListDebitsHook();

  const query = useQuery();

  const filters = {
    barcode: query.get('barcode'),
    integration_id: query.get('integration_id'),
  };

  const app = selectorAppsRedux.data?.find(
    (a) => a.id === filters?.integration_id
  );

  const selectorRedux = {
    SIGNEDIN: useSelector(auth.selector.selectSignedIn),
  };

  React.useEffect(() => {
    if (app) {
      const requireUser =
        app?.require_selfie ||
        app?.require_document ||
        app?.require_bgc ||
        app?.require_user;
      setValid(!requireUser || (selectorRedux.SIGNEDIN && requireUser));
    }
  }, [app]);

  React.useEffect(() => {
    if (loading === true || error[0]) {
      return undefined;
    }

    const hasFilters = Object.values(filters).every((f) => !!f);

    if (hasFilters) {
      handleUpdateFilters({
        ...debits.initialState.filters,
        ...filters,
      });
    }
  }, []);

  return (
    <Box
      display="grid"
      gap={4}
      minHeight={{
        lg: 'calc(100vh - 410px)',
      }}
      alignItems="flex-start"
      gridTemplateColumns={{
        xs: '1fr',
        lg: '1fr',
      }}
    >
      <Box position="relative" height="100%">
        {results?.length > 0 && <BilletComponent />}

        {results?.length === 0 && loading !== null && <NoFound />}

        {loading === null && <FirstRender />}

        {loading && (
          <Box
            bgcolor="white"
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex={9999999999999}
          >
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default DebtBilletComponent;
